import React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
const HomePageSubscribe = () => {
  return (
    <div
      className="bg-center bg-cover flex justify-center items-center py-8"
      style={{
        backgroundImage:
          "url('https://yogalife.brickthemes.com/wp-content/uploads/2021/12/tropical-leaves-background.jpg')",
      }}
    >
      <div
        className="xl:w-1/2 lg:w-2/3 w-[90%]  rounded-xl bg-transparent flex gap-6 py-8 my-8 justify-center items-center flex-col"
        style={{
          backgroundImage:
            "linear-gradient(160deg, #D6ECE105 0%, #EEF9F4 100%)",
        }}
      >
        <span className="md:text-3xl text-2xl font-playfair text-[#17543E] font-semibold ">
          Subscribe Our Newsletter
        </span>
        <form >
          <div className="flex flex-row">
            <input
              placeholder="Email *"
              required
              className="sm:py-4 py-2 md:w-[400px]  outline-none text-sm  placeholder:text-[#CFA649] px-3 sm:px-[20px] text-[#CFA649] bg-[#FFFFFF47] font-lato font-light border border-[#CFA649]"
             
            />
            <button className="flex justify-center  items-center sm:px-[20px] px-2 text-[16px] font-raleway text-white font-bold py-4 outline-none bg-[#cfa649] hover:opacity-80 transition-all hover:duration-200">
              SIGNUP &nbsp; <MailOutlineIcon  />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HomePageSubscribe;
